import { createDrawerEventBinder, plainText } from './cart_drawer_utils.js';

export function initCartDrawerGiftActions({ setLoading, load, drawerSelector }) {
    const onDrawer = createDrawerEventBinder(drawerSelector);

    // Atualiza os dados de presente e brinde do carrinho.
    onDrawer('change', '[data-cart-drawer-present]', function() {
        setLoading(true);

        $.ajax({
            url: 'index.php?route=common/cart_drawer/update',
            type: 'post',
            data: { key: $(this).attr('data-cart-drawer-present'), present: this.checked ? 1 : 0 },
            dataType: 'json',
            complete: function() {
                load();
            }
        });
    });

    // Embalagem para presente do carrinho inteiro: o servidor alterna a partir do estado atual
    onDrawer('change', '[data-cart-drawer-present-cart]', function() {
        setLoading(true);

        $.ajax({
            url: 'index.php?route=checkout/cart/giftWrapping',
            type: 'post',
            data: { present: $(this).attr('data-cart-drawer-present-cart') },
            dataType: 'json',
            complete: function() {
                load();
            }
        });
    });

    // Brinde: aceitar ou recusar (mesmo endpoint do carrinho normal)
    function sendGift($block, data) {
        const $error = $block.find('.cart-drawer-gift__error');

        $error.prop('hidden', true);
        setLoading(true);

        $.ajax({
            url: 'index.php?route=checkout/cart/setGift',
            type: 'post',
            data: data,
            dataType: 'json',
            success: function(json) {
                if (json.success) {
                    load();
                    return;
                }

                setLoading(false);

                // Brinde que depende de cupom exclusivo: a decisão é feita na página do carrinho
                if (json.wait_coupon_exclusive) {
                    window.location.href = '/carrinho';
                    return;
                }

                $error.text(plainText(json.error) || $block.attr('data-msg-error')).prop('hidden', false);
            },
            error: function() {
                setLoading(false);
                $error.text($block.attr('data-msg-error')).prop('hidden', false);
            }
        });
    }

    // Brinde recusado: "Quero o brinde" volta a oferecê-lo
    onDrawer('click', '[data-cart-drawer-gift-restore]', function() {
        setLoading(true);

        $.ajax({
            url: 'index.php?route=common/cart_drawer/restoreGift',
            type: 'post',
            dataType: 'json',
            complete: function() {
                load();
            }
        });
    });

    // A imagem do brinde acompanha a opção escolhida
    onDrawer('change', '.cart-drawer-gift__select', function() {
        const image = $(this).find('option:selected').attr('data-image');

        $(this).closest('[data-cart-drawer-gift]').find('.cart-drawer-gift__image img').attr('src', image);
    });

    onDrawer('click', '[data-cart-drawer-gift-accept]', function() {
        const $block = $(this).closest('[data-cart-drawer-gift]');
        const $option = $block.find('.cart-drawer-gift__select option:selected');

        sendGift($block, {
            product_id: $block.find('.cart-drawer-gift__select').val(),
            product_name: $option.attr('data-name'),
            product_image: $option.attr('data-image'),
            gift_id: $option.attr('data-gift-id'),
            current_total_gift: $block.attr('data-total'),
            reference: $option.attr('data-reference'),
            gtin: $option.attr('data-gtin')
        });
    });

    onDrawer('click', '[data-cart-drawer-gift-refuse]', function() {
        const $block = $(this).closest('[data-cart-drawer-gift]');

        sendGift($block, { rejected: true, gift_id: $block.find('.cart-drawer-gift__select option:selected').attr('data-gift-id') });
    });
}
